
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createCliente } from '../api/clientesApi';
import { toast } from 'react-hot-toast';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input'; // Assuming you have this component
import { Label } from '../components/ui/Label.jsx';   // Assuming you have this component

const NovoClientePage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        telefone: '',
        endereco: {
            logradouro: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            estado: '',
            cep: ''
        }
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            endereco: {
                ...prev.endereco,
                [name]: value
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Basic validation
        if (!formData.nome || !formData.telefone) {
            toast.error('Nome e Telefone são obrigatórios.');
            setIsLoading(false);
            return;
        }

        try {
            await createCliente(formData);
            toast.success('Cliente criado com sucesso!');
            navigate('/clientes');
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Falha ao criar o cliente.';
            toast.error(errorMessage);
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-4 md:p-8">
            <header className="mb-8">
                <h1 className="text-3xl font-bold text-slate-800">Adicionar Novo Cliente</h1>
                <p className="text-slate-500 mt-1">Preencha os dados abaixo para cadastrar um novo cliente no sistema.</p>
            </header>
            
            <Card className="p-6 md:p-8">
                <form onSubmit={handleSubmit}>
                    <div className="space-y-6">
                        {/* Informações Básicas */}
                        <section>
                            <h2 className="text-xl font-semibold text-slate-700 mb-4 border-b pb-2">Informações de Contato</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <Label htmlFor="nome">Nome Completo</Label>
                                    <Input id="nome" name="nome" type="text" value={formData.nome} onChange={handleChange} placeholder="Ex: João da Silva" required />
                                </div>
                                <div>
                                    <Label htmlFor="telefone">Telefone / WhatsApp</Label>
                                    <Input id="telefone" name="telefone" type="tel" value={formData.telefone} onChange={handleChange} placeholder="(11) 99999-9999" required />
                                </div>
                                <div>
                                    <Label htmlFor="email">E-mail</Label>
                                    <Input id="email" name="email" type="email" value={formData.email} onChange={handleChange} placeholder="joao.silva@email.com" />
                                </div>
                            </div>
                        </section>

                        {/* Endereço */}
                        <section>
                            <h2 className="text-xl font-semibold text-slate-700 mb-4 border-b pb-2">Endereço</h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                <div className="md:col-span-2">
                                    <Label htmlFor="logradouro">Logradouro</Label>
                                    <Input id="logradouro" name="logradouro" type="text" value={formData.endereco.logradouro} onChange={handleAddressChange} placeholder="Ex: Rua das Flores" />
                                </div>
                                <div>
                                    <Label htmlFor="numero">Número</Label>
                                    <Input id="numero" name="numero" type="text" value={formData.endereco.numero} onChange={handleAddressChange} placeholder="123" />
                                </div>
                                <div>
                                    <Label htmlFor="bairro">Bairro</Label>
                                    <Input id="bairro" name="bairro" type="text" value={formData.endereco.bairro} onChange={handleAddressChange} placeholder="Centro" />
                                </div>
                                <div>
                                    <Label htmlFor="cidade">Cidade</Label>
                                    <Input id="cidade" name="cidade" type="text" value={formData.endereco.cidade} onChange={handleAddressChange} placeholder="São Paulo" />
                                </div>
                                <div>
                                    <Label htmlFor="estado">Estado</Label>
                                    <Input id="estado" name="estado" type="text" value={formData.endereco.estado} onChange={handleAddressChange} placeholder="SP" />
                                </div>
                                 <div className="md:col-span-3">
                                    <Label htmlFor="complemento">Complemento</Label>
                                    <Input id="complemento" name="complemento" type="text" value={formData.endereco.complemento} onChange={handleAddressChange} placeholder="Apto 101, Bloco B" />
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="mt-8 flex justify-end gap-3">
                        <Button type="button" variant="outline" onClick={() => navigate('/clientes')} disabled={isLoading}>
                            Cancelar
                        </Button>
                        <Button type="submit" disabled={isLoading}>
                            {isLoading ? 'Salvando...' : 'Salvar Cliente'}
                        </Button>
                    </div>
                </form>
            </Card>
        </div>
    );
};

export default NovoClientePage;
